// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { Lock, Mail, AlertTriangle } from 'lucide-react';
import { supabase } from '../../utils/supabaseClient';
import logger from '../../utils/logger';
import './SessionExpiredModal.css';

const SessionExpiredModal = ({ userEmail, onReauthenticate }) => {
  const [credentials, setCredentials] = useState({ email: userEmail || '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const passwordRef = useRef(null);

  // Auto-focus password field since email is pre-filled
  useEffect(() => {
    if (passwordRef.current) {
      passwordRef.current.focus();
    }
  }, []);

  // Keep email in sync if userEmail prop changes
  useEffect(() => {
    if (userEmail) {
      setCredentials(prev => ({ ...prev, email: userEmail }));
    }
  }, [userEmail]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { data, error: authError } = await supabase.auth.signInWithPassword({
        email: credentials.email,
        password: credentials.password,
      });

      if (authError) {
        if (authError.message.includes('Email not confirmed')) {
          setError('Please confirm your email before signing in.');
        } else {
          setError(authError.message);
        }
        return;
      }

      if (data.user && data.session) {
        // Pass the new session back to App for cookie re-establishment
        onReauthenticate(data.user, data.session);
      }
    } catch (err) {
      logger.error('Re-authentication error:', err);
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-icon">
          <AlertTriangle size={32} />
        </div>
        <div className="session-expired-header">
          <h2>Session Expired</h2>
          <p>Your session has timed out for security. Please sign in again to continue where you left off.</p>
        </div>

        <form onSubmit={handleSubmit} className="session-expired-form">
          <div className="session-input-group">
            <Mail className="session-input-icon" size={18} />
            <input
              type="email"
              placeholder="Email address"
              value={credentials.email}
              onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>

          <div className="session-input-group">
            <Lock className="session-input-icon" size={18} />
            <input
              ref={passwordRef}
              type="password"
              placeholder="Password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="session-error-message">{error}</div>}

          <button type="submit" className="session-reauth-button" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In & Continue'}
          </button>
        </form>

        <p className="session-expired-note">
          Your work is preserved — you'll pick up right where you left off.
        </p>
      </div>
    </div>
  );
};

export default SessionExpiredModal;

